import createIcon from '../../createIcon';

/**
 * @component @name AreaChart
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxMy41VjIwLjVIMjFWMTlMMTIgMTJMOCAxNy41TDMgMTMuNVpNMyA3LjVMNyAxMC41TDEyIDMuNUwxNyA3LjVIMjFWMTYuNDdMMTEuNiA5LjE2TDcuNjIgMTQuNjRMMyAxMC45NFY3LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AreaChart = createIcon('AreaChart', [
  [
    'path',
    {
      d: 'M3 13.5V20.5H21V19L12 12L8 17.5L3 13.5ZM3 7.5L7 10.5L12 3.5L17 7.5H21V16.47L11.6 9.16L7.62 14.64L3 10.94V7.5Z',
      key: 'c1iz0k',
    },
  ],
]);

export default AreaChart;
